import React from 'react'
import './css/OccasionCard.css'

function OccasionCard({image, text}) {
  return (
    <div className='OccasionCard'>
        <div className='Image'>
          <img src={image} alt='CardImage' />
        </div>
        <h3>{text}</h3>
    </div>
  )
}

export default OccasionCard